import { Tooltip as ReactTooltip } from 'react-tooltip'

import { isTouchDevice } from '../helpers.ts'

export const Tooltip = () => (
  <ReactTooltip
    anchorSelect=".my-anchor-element"
    place="top"
    opacity={1}
    offset={12}
    className="tooltip"
    classNameArrow="arrow"
    openOnClick={isTouchDevice}
    clickable={true}
  ></ReactTooltip>
)
